import { AppIntroFlow } from '@components/AppIntroFlow/index';
import { Trans, useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { PageStateContext } from '@components/Providers/PageStateProvider';
import { useStoreState } from 'easy-peasy';
import { Alert } from '@reverse-hr/pattern-library';
import classNames from 'classnames';
import { JOB_PAGE_STATES } from '@model/Job/_constants/Job.constants';
import { candidatesSelector } from '@model/Candidate/Candidate.selectors';
import { CANDIDATE_EVENT_TYPES } from '@app/constants/candidate';
import { selectorJobIsReverseMarketing } from '@model/Job/Job.selectors';

export const InterviewingHeader = () => {
  const { t } = useTranslation();
  const candidates = useStoreState(candidatesSelector);
  const pageState = useContext(PageStateContext);
  const isJobReverseMarketing = useStoreState(selectorJobIsReverseMarketing);

  const isPageStateDoing = pageState === JOB_PAGE_STATES.DOING;

  const isAlertMessageVisible = checkAlertMessageVisibility({
    candidates: candidates.results,
    isPageStateDoing,
  });

  const isChatImgVisible =
    !isJobReverseMarketing && pageState === JOB_PAGE_STATES.DONE;

  const wrapperClassNames = classNames('rev-u-px-16 rev-o-col-12', {
    'rev-o-col--medium-6': !isPageStateDoing,
    'rev-o-col--medium-9': isPageStateDoing,
  });

  const introFlowAdditionalClassNames = classNames({
    'c-app-intro-flow--full': isPageStateDoing,
  });

  const subtitleLabel = isJobReverseMarketing
    ? 'interviewing.header.marketing.subtitle'
    : 'interviewing.header.subtitle';

  const subtitleContext = candidates.results.length > 0 ? '' : 'bis';

  const chatImageSrc = __ENVIRONMENT_CONFIG__.IS_THEME_AKI
    ? `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/aaron-king/chat.png`
    : `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/chat.png`;

  const talentsImageSrc = `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/talents.png`;

  return (
    <div className={wrapperClassNames}>
      <div className="c-interviewing-header__intro">
        {isJobReverseMarketing && (
          <img
            className="c-interviewing-header__talents-image"
            src={talentsImageSrc}
          />
        )}

        <AppIntroFlow
          title={t('interviewing.header.title', {
            context: isJobReverseMarketing ? 'marketing' : '',
          })}
          body={<Trans i18nKey={subtitleLabel} context={subtitleContext} />}
          className={introFlowAdditionalClassNames}
        />
      </div>

      {isAlertMessageVisible && (
        <div className="rev-u-mt-48">
          <Alert modifier="" closable type="warning" icon="icn-warning-outline">
            <Trans
              i18nKey="interviewing.header.alert"
              components={{ strong: <strong /> }}
            />
          </Alert>
        </div>
      )}

      {isChatImgVisible && (
        <img
          data-testid="interviewing-page-img"
          className="rev-u-mt-32"
          width="256"
          src={chatImageSrc}
          alt={t('interviewing.header.title')}
        />
      )}
    </div>
  );
};

const checkAlertMessageVisibility = ({ candidates, isPageStateDoing }) => {
  if (!isPageStateDoing) {
    return false;
  }

  return !!candidates.find(candidate => {
    if (candidate.discardedAt) {
      return false;
    }

    return !!candidate.events.find(event => {
      return event.type === CANDIDATE_EVENT_TYPES.OFFER_MADE;
    });
  });
};
